<template>
  <div class="profit-module">
    <!-- 输入区域 -->
    <div class="input-section">
      <div class="input-row">
        <div class="input-item">
          <label class="input-label">所得税率(%)</label>
          <input
            type="number"
            v-model.number="localProfitData.lirun.incomeTaxRate"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            max="33"
            @change="handleInputChange"
          />
        </div>

        <div class="input-item">
          <label class="input-label">法定盈余公积金率(%)</label>
          <input
            type="number"
            v-model.number="localProfitData.lirun.法定盈余公积金Rate"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            max="100"
            @change="handleInputChange"
          />
        </div>

        <div class="input-item">
          <label class="input-label">任意盈余公积金率(%)</label>
          <input
            type="number"
            v-model.number="localProfitData.lirun.任意盈余公积金Rate"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            max="100"
            @change="handleInputChange"
          />
        </div>
        <div class="input-item">
          <label class="input-label">补贴收入(万元)</label>
          <input
            type="number"
            v-model.number="localProfitData.lirun.subsidyIncome"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            @change="handleInputChange"
          />
        </div>

        <div class="input-item">
          <label class="input-label">优先股分配比例(%)</label>
          <input
            type="number"
            v-model.number="localProfitData.lirun.preferredStockRate"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            max="100"
            @change="handleInputChange"
          />
        </div>
      </div>
    </div>

    <!-- 利润计算结果表格 -->
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="profit-table">
          <thead>
            <tr>
              <th class="seq-col">序号</th>
              <th>项目</th>
              <th>合计</th>
              <th
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'header-' + index"
              >
                {{ index }}
              </th>
            </tr>
            <tr>
              <th class="seq-col"></th>
              <th style="text-align: center">建设期/经营期</th>
              <th class="total-col"></th>
              <th
                :colspan="localProfitData.constructionPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                建设期
              </th>
              <th
                :colspan="localProfitData.operationPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                经营期
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="seq-col">1</td>
              <td class="item-col">营业收入</td>
              <td class="total-col">
                {{ formatNumber(localProfitData?.lirun?.revenueTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'revenue-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.revenueByYear[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2</td>
              <td class="item-col">营业税金及附加</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.businessTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'business-tax-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.businessTaxByYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3</td>
              <td class="item-col">增值税</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.vatTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'vat-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.vatByYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">4</td>
              <td class="item-col">总成本费用</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.totalCostTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'cost-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.totalCostByYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">5</td>
              <td class="item-col">补贴收入</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.subsidyIncomeTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'subsidy-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.subsidyIncomeByYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">6</td>
              <td class="item-col">利润总额</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.profitBeforeTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'profit-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.profitBeforeTaxByYear?.[index - 1] ||
                      0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">7</td>
              <td class="item-col">弥补以前年度亏损</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.lossCompensationTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'loss-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.lossCompensationByYear?.[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">8</td>
              <td class="item-col">应纳税所得额</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.taxableIncomeTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'taxable-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.taxableIncomeByYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">9</td>
              <td class="item-col">所得税</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.incomeTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'tax-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.incomeTaxYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">10</td>
              <td class="item-col">净利润</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.netProfit) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'net-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.netProfitYear?.[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">11</td>
              <td class="item-col">期初未分配利润</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localProfitData.lirun.beginningUndistributedProfitTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'begin-undist-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.beginningUndistributedProfitByYear?.[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">12</td>
              <td class="item-col">可供分配的利润</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localProfitData.lirun.availableForDistributionTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'available-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun?.availableForDistributionByYear?.[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">13</td>
              <td class="item-col">提取法定盈余公积金</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.法定盈余公积金Total) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'reserve-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.法定盈余公积金Year[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">14</td>
              <td class="item-col">可供投资者分配的利润</td>
              <td class="total-col">
                {{
                  formatNumber(localProfitData.lirun.availableForInvestorsTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'investors-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.availableForInvestorsByYear[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">15</td>
              <td class="item-col">应付优先股股利</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localProfitData.lirun.preferredStockDividendTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'preferred-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.preferredStockDividendByYear[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">16</td>
              <td class="item-col">提取任意盈余公积金</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.任意盈余公积金Total) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'arbitrary-reserve-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.任意盈余公积金Year[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">17</td>
              <td class="item-col">应付普通股股利</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.commonDividendTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'common-dividend-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.commonDividendByYear[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">18</td>
              <td class="item-col">各投资方利润分配</td>
              <td class="total-col"></td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'investment-' + index"
              ></td>
            </tr>
            <tr>
              <td class="seq-col">19</td>
              <td class="item-col">未分配利润</td>
              <td class="total-col">
                {{
                  formatNumber(localProfitData.lirun.undistributedProfitTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'undist-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.undistributedProfitByYear[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">20</td>
              <td class="item-col">息税前利润</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.ebitTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'ebit-' + index"
              >
                {{
                  formatNumber(localProfitData.lirun.ebitByYear[index - 1] || 0)
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">21</td>
              <td class="item-col">息税折旧摊销前利润</td>
              <td class="total-col">
                {{ formatNumber(localProfitData.lirun.ebitdaTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localProfitData.operationPeriod +
                localProfitData.constructionPeriod"
                :key="'ebitda-' + index"
              >
                {{
                  formatNumber(
                    localProfitData.lirun.ebitdaByYear[index - 1] || 0
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 底部固定的利润率显示框 -->
    <div class="profit-indicators">
      <div class="indicator-section">
        <div class="section-title">正常年销售利润率</div>
        <div class="indicator-row">
          <div class="indicator-item">
            <div class="indicator-label">利润率（利润总额）</div>
            <div class="indicator-value">
              {{ formatPercent(salesProfitRate) }}
            </div>
          </div>
          <div class="indicator-item">
            <div class="indicator-label">利润率（净利润）</div>
            <div class="indicator-value">
              {{ formatPercent(salesNetProfitRate) }}
            </div>
          </div>
        </div>
      </div>

      <div class="indicator-section">
        <div class="section-title">正常年全部投资利润率</div>
        <div class="indicator-row">
          <div class="indicator-item">
            <div class="indicator-label">利润率（利润总额）</div>
            <div class="indicator-value">
              {{ formatPercent(investmentProfitRate) }}
            </div>
          </div>
          <div class="indicator-item">
            <div class="indicator-label">利润率（净利润）</div>
            <div class="indicator-value">
              {{ formatPercent(investmentNetProfitRate) }}
            </div>
          </div>
        </div>
      </div>

      <div class="indicator-section">
        <div class="section-title">正常年资本金利润率</div>
        <div class="indicator-row">
          <div class="indicator-item">
            <div class="indicator-label">利润率（利润总额）</div>
            <div class="indicator-value">
              {{ formatPercent(capitalProfitRate) }}
            </div>
          </div>
          <div class="indicator-item">
            <div class="indicator-label">利润率（净利润）</div>
            <div class="indicator-value">
              {{ formatPercent(capitalNetProfitRate) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { profitCalculation } from "@/utils/comp.js";

export default {
  name: "ProfitModule",
  data() {
    return {
      localProfitData: {
        lirun: {
          incomeTaxRate: 25, // 所得税率，默认25%，最高33%
          法定盈余公积金Rate: 0, // 法定盈余公积金比率，默认0%
          任意盈余公积金Rate: 0, // 任意盈余公积金比率，默认0%
          subsidyIncome: 0, // 补贴收入，默认0万元
          total: 0, // 利润总额合计
          netProfit: 0, // 净利润合计
          incomeTaxTotal: 0, // 所得税合计
          法定盈余公积金Total: 0, // 法定盈余公积金合计
          任意盈余公积金Total: 0, // 任意盈余公积金合计
          year: [], // 分年利润总额
          netProfitYear: [], // 分年净利润
          incomeTaxYear: [], // 分年所得税
          法定盈余公积金Year: [], // 分年法定盈余公积金
          任意盈余公积金Year: [], // 分年任意盈余公积金
          // 新增利润表项目
          revenueTotal: 0, // 营业收入合计
          revenueByYear: [], // 分年营业收入
          businessTaxTotal: 0, // 营业税金及附加合计
          businessTaxByYear: [], // 分年营业税金及附加
          vatTotal: 0, // 增值税合计
          vatByYear: [], // 分年增值税
          totalCostTotal: 0, // 总成本费用合计
          totalCostByYear: [], // 分年总成本费用
          subsidyIncomeTotal: 0, // 补贴收入合计
          subsidyIncomeByYear: [], // 分年补贴收入
          profitBeforeTaxTotal: 0, // 利润总额合计
          profitBeforeTaxByYear: [], // 分年利润总额
          lossCompensationTotal: 0, // 弥补以前年度亏损合计
          lossCompensationByYear: [], // 分年弥补以前年度亏损
          taxableIncomeTotal: 0, // 应纳税所得额合计
          taxableIncomeByYear: [], // 分年应纳税所得额
          undistributedProfitTotal: 0, // 未分配利润合计
          undistributedProfitByYear: [], // 分年未分配利润
          ebitTotal: 0, // 息税前利润合计
          ebitByYear: [], // 分年息税前利润
          ebitdaTotal: 0, // 息税折旧摊销前利润合计
          ebitdaByYear: [], // 分年息税折旧摊销前利润
          ytaxableIncomeTotal: 0, //所税计算依据合计
          ytaxableIncomeByYear: [], //所得税计算依据分年
        },
        operationPeriod: 14,
        constructionPeriod: 1,
      }, // 直接存储计算函数返回的结果
    };
  },
  computed: {
    ...mapState(["projectData"]),
    // 计算正常年索引
    normalYearIndex() {
      const normalYear = this.projectData?.基础数据?.normalYear || 0;
      return Math.max(0, normalYear - 1);
    },
    // 总投资（正常年数据）
    totalInvestment() {
      return this.projectData?.总投资估算?.总表?.总投资?.合计 || 0;
    },
    // 资本金（正常年数据）
    capitalAmount() {
      return (
        this.projectData?.资金筹措及分年投资计划?.资金筹措?.项目资本金
          ?.amount || 0
      );
    },
    // 营业收入（正常年数据）
    normalYearRevenue() {
      return (
        this.localProfitData?.lirun?.revenueByYear?.[this.normalYearIndex] || 0
      );
    },
    // 利润总额（正常年数据）
    normalYearProfitBeforeTax() {
      return (
        this.localProfitData?.lirun?.profitBeforeTaxByYear?.[
          this.normalYearIndex
        ] || 0
      );
    },
    // 净利润（正常年数据）
    normalYearNetProfit() {
      return (
        this.localProfitData?.lirun?.netProfitYear?.[this.normalYearIndex] || 0
      );
    },
    // 投资利润率（利润总额）= 正常年利润总额 / 总投资 × 100%
    investmentProfitRate() {
      if (!this.normalYearProfitBeforeTax || !this.totalInvestment) {
        return 0;
      }
      return (this.normalYearProfitBeforeTax / this.totalInvestment) * 100;
    },
    // 投资净利润率 = 正常年净利润 / 总投资 × 100%
    investmentNetProfitRate() {
      if (!this.normalYearNetProfit || !this.totalInvestment) {
        return 0;
      }
      return (this.normalYearNetProfit / this.totalInvestment) * 100;
    },
    // 销售利润率（利润总额）= 正常年利润总额 / 正常年营业收入 × 100%
    salesProfitRate() {
      if (!this.normalYearProfitBeforeTax || !this.normalYearRevenue) {
        return 0;
      }
      return (this.normalYearProfitBeforeTax / this.normalYearRevenue) * 100;
    },
    // 销售净利润率 = 正常年净利润 / 正常年营业收入 × 100%
    salesNetProfitRate() {
      if (!this.normalYearNetProfit || !this.normalYearRevenue) {
        return 0;
      }
      return (this.normalYearNetProfit / this.normalYearRevenue) * 100;
    },
    // 资本金利润率（利润总额）= 正常年利润总额 / 资本金 × 100%
    capitalProfitRate() {
      if (!this.normalYearProfitBeforeTax || !this.capitalAmount) {
        return 0;
      }
      return (this.normalYearProfitBeforeTax / this.capitalAmount) * 100;
    },
    // 资本金净利润率 = 正常年净利润 / 资本金 × 100%
    capitalNetProfitRate() {
      if (!this.normalYearNetProfit || !this.capitalAmount) {
        return 0;
      }
      return (this.normalYearNetProfit / this.capitalAmount) * 100;
    },
  },

  // 移除监听，改为直接调用计算函数
  created() {
    this.localProfitData = profitCalculation();
  },

  methods: {
    // 格式化数字显示
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留2位小数
      const formatted = num.toFixed(2);
      // 如果值为0，则显示为空
      if (parseFloat(formatted) === 0) {
        return "";
      }
      // 返回格式化后的数字，避免使用“...”
      return formatted;
    },

    // 格式化百分比显示
    formatPercent(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留2位小数并添加百分号
      const formatted = num.toFixed(2) + "%";
      // 如果值为0%，则显示为空
      if (parseFloat(num.toFixed(2)) === 0) {
        return "";
      }
      // 返回格式化后的百分比
      return formatted;
    },

    // 更新期别类型分组信息
    updatePeriodGroups() {
      const constructionPeriod =
        this.projectData?.基础数据?.constructionPeriod || 0;
      const totalYears = this.years.length;
      const periodGroups = [];

      if (constructionPeriod > 0) {
        // 如果有建设期
        periodGroups.push({
          type: "建设期",
          span: constructionPeriod,
          startIndex: 0,
        });

        if (totalYears > constructionPeriod) {
          // 如果还有经营期
          periodGroups.push({
            type: "经营期",
            span: totalYears - constructionPeriod,
            startIndex: constructionPeriod,
          });
        }
      } else {
        // 如果没有建设期，全部为经营期
        periodGroups.push({
          type: "经营期",
          span: totalYears,
          startIndex: 0,
        });
      }

      this.periodGroups = periodGroups;
    },

    // 处理输入变化
    handleInputChange() {
      // 确保projectData存在
      let projectData = this.$store.state.projectData;

      let s = this.localProfitData.lirun;
      projectData.营业收入税金及利润.利润 = s;

      if (!this.projectData) {
        this.$store.commit("SET_PROJECT_DATA", projectData);
      }

      setTimeout(() => {
        this.localProfitData = profitCalculation();
      }, 100);
    },
  },
};
</script>

<style scoped>
.profit-module {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.input-section {
  padding: 15px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.input-row {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.input-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.input-number {
  width: 120px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  text-align: right;
}

.input-number:focus {
  border-color: #409eff;
}

.table-wrapper {
  flex: 1;
  /* 移除overflow: hidden，确保表格可以水平扩展 */
  display: flex;
  flex-direction: column;
  /* 动态高度，确保表格不会超出视口 */
  min-height: 300px;
  max-height: calc(100vh - 200px);
  padding: 5px 0;
}

.table-scroll-area {
  flex: 1;
  overflow: auto;
  /* 支持水平和垂直滚动 */
  overflow-x: auto;
  overflow-y: auto;
  /* 确保滚动条可见 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 美化滚动条 */
.table-scroll-area::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.profit-table {
  /* 使用auto而不是fixed，让表格宽度根据内容自动调整 */
  table-layout: auto;
  border-collapse: collapse;
  font-size: 12px;
  /* 当列数少时，表格撑满容器宽度 */
  min-width: 100%;
  /* 确保表格内容不会被压缩 */
  white-space: nowrap;
  margin-bottom: 10px;
}

.profit-table th,
.profit-table td {
  text-align: center;
  /* 缩小单元格边框 */
  border: 0.5px solid #dfe6ec;
  /* 设置文字不换行 */
  white-space: nowrap;
  overflow: visible;
  /* 确保不显示省略号 */
  text-overflow: clip;
}

.total-col,
.year-col {
  text-align: right !important;
  padding-right: 10px !important;
}

.profit-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.seq-col {
  width: 50px;
  min-width: 50px;
}

.item-col {
  /* width: 150px; */
  /* min-width: 150px; */
  text-align: left !important;
  padding: 0 10px 0 5px;
}

.total-col {
  width: 100px;
  min-width: 100px;
  font-weight: 600;
}

.year-col {
  padding: 4px 2px;
  /* 设置最小宽度，确保表格有足够的宽度来触发水平滚动 */
  min-width: 60px;
}

/* 底部固定的利润率显示框样式 */
.profit-indicators {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 1px solid #dcdfe6;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.indicator-section {
  flex: 1;
  min-width: 200px;
  padding: 10px;
  border-radius: 4px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
}

.indicator-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.indicator-item {
  text-align: center;
  flex: 1;
}

.indicator-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
  word-break: keep-all;
}

.indicator-value {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  text-align: center;
}

/* 确保表格区域有足够的底部边距，避免被底部固定框遮挡 */
.table-wrapper {
  margin-bottom: 120px;
}

.period-type-col {
  background: #e8f4f8;
}

.summary-row {
  background: #f0f9eb;
  font-weight: 600;
}

.summary-row:hover {
  background: #e1f3d8;
}

.highlight-row {
  background: #fff7e6;
  font-weight: 600;
}

.highlight-row:hover {
  background: #ffe4b3;
}

.bold-row {
  font-weight: 600;
}

.bold-row:hover {
  background: #f5f5f5;
}
</style>
